<div class="container">
  <div class="row">
    <div class="col">
      <div class="registration-page-container">
        <div class="registration-page-logo">
          <img
            src="assets/images/logo-tr@3x.png"
            srcset="assets/images/logo-tr@3x.png 2x, assets/images/logo-tr@3x.png 3x"
            class="logo"
            width="50%"
          />
        </div>
        <div class="registration-page-title">Create&nbsp;an&nbsp;Account</div>

        <ng-container *ngIf="!isRegistered; else registered">
          <div class="registration-page-subtitle">
            Already have an account?&nbsp;<a
              role="button"
              class="login-link"
              routerLink="/"
              >Log in</a
            >
          </div>
          <form name="registerForm"
                (ngSubmit)="submitForm(registerForm.value)"
                [formGroup]="registerForm"
                novalidate>
            <div class="mb-2 row">
              <div class="col-md-2 p-1">
                <div class="custom-input-box">
                  <label for="titleId" class="form-label fs-14 text-start mb-1">Title</label>
                  <input type="text"
                         class="form-control mt-0 mb-1"
                         [ngClass]="{
          'form-required-border':
            submitted && registerForm.hasError('required', 'title')
        }"
                         formControlName="title"
                         placeholder="Title"
                         id="titleId"
                         #titleInput />
                  <span class="text-danger"
                        *ngIf="submitted && registerForm.hasError('required', 'title')">
                    Title is required
                  </span>
                </div>
              </div>
              <div class="col-md-5 p-1">
                <div class="custom-input-box">
                  <label for="firstNameId" class="form-label fs-14 text-start mb-1">First Name</label>
                  <input type="text"
                         class="form-control mt-0 mb-1"
                         [ngClass]="{
          'form-required-border':
            submitted && registerForm.hasError('required', 'firstName')
        }"
                         formControlName="firstName"
                         placeholder="First Name"
                         id="firstNameId" />
                  <span class="text-danger"
                        *ngIf="submitted && registerForm.hasError('required', 'firstName')">
                    First name is required
                  </span>
                </div>
              </div>
              <div class="col-md-5 p-1">
                <div class="custom-input-box">
                  <label for="lastNameId" class="form-label fs-14 text-start mb-1">Last Name</label>
                  <input type="text"
                         class="form-control mt-0 mb-1"
                         [ngClass]="{
          'form-required-border':
            submitted && registerForm.hasError('required', 'lastName')
        }"
                         placeholder="Last Name"
                         formControlName="lastName"
                         id="lastNameId" />
                  <span class="text-danger"
                        *ngIf="submitted && registerForm.hasError('required', 'lastName')">
                    Last name is required
                  </span>
                </div>
              </div>
            </div>
            <div class="mb-2 row">
              <div class="col-12 p-1">
                <div class="custom-input-box">
                  <label for="accreditationNumber" class="form-label fs-14 text-start mb-1">Veterinary Registration / Accreditation Number</label>
                  <input type="text"
                         class="form-control mt-0 mb-1"
                         [ngClass]="{
           'form-required-border ':
             submitted &&
             registerForm.hasError('required', 'accreditationNumber')
         }"
                         placeholder="Veterinary Registration / Accreditation Number"
                         formControlName="accreditationNumber"
                         id="accreditationNumber" />
                  <span class="text-danger"
                        *ngIf="submitted && registerForm.hasError('required', 'accreditationNumber')">
                    Accreditation Number name is required
                  </span>
                </div>
              </div>
            </div>
            <div class="mb-2 row">
              <div class="col-12 p-1">
                <div class="custom-input-box">
                  <label for="businessNameId" class="form-label fs-14 text-start mb-1">Business Name</label>
                  <input type="text"
                         class="form-control mt-0 mb-1"
                         [ngClass]="{
                      'form-required-border ':
                        submitted &&
                        registerForm.hasError('required', 'businessName')
                    }"
                         placeholder="Business Name"
                         formControlName="businessName"
                         id="businessNameId" />
                  <span class="text-danger"
                        *ngIf="submitted && registerForm.hasError('required', 'businessName')">
                    Business name is required
                  </span>
                </div>
              </div>
            </div>
            <div class="mb-2 row">
              <div class="col-12 p-1">
                <div class="custom-input-box">
                  <label for="emailAddressId" class="form-label fs-14 text-start mb-1">Email</label>
                  <input type="email"
                         class="form-control mt-0 mb-1"
                         [ngClass]="{
                      'form-required-border ':
                        submitted &&
                        registerForm.hasError('required', 'emailAddress')
                    }"
                         placeholder="Email"
                         formControlName="emailAddress"
                         id="emailAddressId" />
                  <span class="text-danger"
                        *ngIf="submitted && registerForm.hasError('required', 'emailAddress')">
                    Email is required
                  </span>
                  <span class="text-danger"
                        *ngIf="registerForm.get('emailAddress').hasError('email')">
                    Please enter a valid email address
                  </span>
                  <span class="text-danger" *ngIf="isUniquieEmail">
                    {{ responseError }}
                  </span>
                </div>
              </div>
            </div>
            <div class="mb-2 row">
              <div class="col-12 p-1">
                <div class="custom-input-box">
                  <label for="regionId" class="form-label fs-14 mt-1 text-start mb-1">Region</label>
                  <select class="form-control mt-0 mb-1" (change)="SetCountryISO($event)"
                          [ngClass]="{
                'form-required-border ':
                  submitted && registerForm.hasError('required', 'region')
              }"
                          formControlName="region"
                          id="regionId">
                    <option value="">Select Region</option>
                    <option *ngFor="let region of regions"
                            [value]="region.region">
                      {{ region.region }}
                    </option>
                  </select>
                  <span class="text-danger"
                        *ngIf="submitted && registerForm.hasError('required', 'region')">
                    Region is required
                  </span>
                </div>
              </div>
            </div>
            <div class="mb-2 row">
              <div class="col-12 p-1">
                <div class="custom-input-box">
                  <label for="mobileId" class="form-label fs-14 mb-0 text-start mb-1">Mobile</label>
                  <ngx-intl-tel-input [cssClass]="'form-control'"
                                      [preferredCountries]="preferredCountries"
                                      [enableAutoCountrySelect]="true"
                                      [enablePlaceholder]="true"
                                      [searchCountryFlag]="true"
                                      [searchCountryField]="[
                         SearchCountryField.Iso2,
                         SearchCountryField.Name,
                         SearchCountryField.DialCode
                       ]"
                                      [selectFirstCountry]="false"
                                      [selectedCountryISO]="selectedCountryISO"
                                      [phoneValidation]="true"
                                      [separateDialCode]="true"
                                      [numberFormat]="PhoneNumberFormat.National"
                                      name="phone"
                                      formControlName="phone">
                  </ngx-intl-tel-input>
                </div>
              </div>
            </div>
            <div class="mb-2 row">
              <div class="col-12 p-1">
                <div class="custom-input-box">
                  <label for="passwordId" class="form-label fs-14 text-start mb-1">Password</label>
                  <input formControlName="password"
                         type="password"
                         class="form-control mt-0 mb-1"
                         [ngClass]="{
                        'form-required-border ':
                          submitted && registerForm.hasError('required', 'password')
                      }"
                         placeholder="Password"
                         id="passwordId" />
                  <span class="text-danger"
                        *ngIf="submitted && registerForm.hasError('required', 'password')">
                    Password is required
                  </span>
                </div>
              </div>
            </div>
            <div class="mb-2 row">
              <div class="col-12 p-1">
                <div class="custom-input-box">
                  <label for="passwordConfirmId" class="form-label fs-14 text-start mb-1">Password (Confirm)</label>
                  <input type="password"
                         class="form-control mt-0 mb-1"
                         [ngClass]="{
                        'form-required-border ':
                          submitted &&
                          registerForm.hasError('required', 'passwordConfirm')
                      }"
                         placeholder="Password (Confirm)"
                         formControlName="passwordConfirm"
                         id="passwordConfirmId" />
                  <span class="text-danger"
                        *ngIf="submitted && registerForm.hasError('required', 'passwordConfirm')">
                    Password (Confirm) is required
                  </span>
                  <span class="text-danger"
                        *ngIf="!registerForm.get('passwordConfirm').hasError('required') &&
                          registerForm.get('passwordConfirm').hasError('passwordsNotMatching')">
                    Passwords must match
                  </span>
                </div>
              </div>
            </div>
            <div class="custom-control custom-checkbox mt-3 mb-3 i-agree-to-terms-checkbox">
              <input type="checkbox"
                     class="custom-control-input"
                     id="terms-condition-checkbox"
                     formControlName="acceptTerms" />
              <label class="custom-control-label" for="terms-condition-checkbox">
                I agree to the
              </label> <a class="pointer cursor-pointer fs-13 ms-1"
                          (click)="openTermsConditionsPopup()">Terms & Conditions</a>
              <span class="text-danger"
                    *ngIf="
                  submitted && registerForm.hasError('required', 'acceptTerms')
                ">
                <br />
                Please agree to the terms & conditions before continuing.
              </span>
            </div>

            <div class="custom-control custom-checkbox mt-3 mb-3 i-agree-to-terms-checkbox">
              <input type="checkbox"
                     class="custom-control-input"
                     id="privacy-policy-checkbox"
                     formControlName="acceptPrivacy" />
              <label class="custom-control-label" for="privacy-policy-checkbox">
                I agree to the
              </label> <a class="pointer cursor-pointer fs-13 ms-1" (click)="openPrivacyPolicyPopup()">Privacy Policy</a>
              <span class="text-danger"
                    *ngIf="
                  submitted &&
                  registerForm.hasError('required', 'acceptPrivacy')
                ">
                <br />
                Please agree to the privacy policy before continuing.
              </span>
            </div>
            <button type="submit"
                    [disabled]="isLoader"
                    class="btn btn-primary w-100 btn-lg">
              <!--<i class="fas fa-spinner fa-spin colorWhite" *ngIf="isLoader">
              </i>-->
              Create Account
            </button>
          </form>
        </ng-container>

        <ng-template #registered>
          <h2 class="mt-5 mb-4">Success!</h2>

          <p>
            You have successfully created your account. Please check your email
            to activate your account.
          </p>

          <button type="button" class="btn btn-primary mt-3" routerLink="/">
            Login Now
          </button>
        </ng-template>
      </div>
    </div>
  </div>
</div>
